import { render, staticRenderFns } from "./publishH5.vue?vue&type=template&id=c3990dc0&scoped=true"
import script from "./publishH5.vue?vue&type=script&lang=js"
export * from "./publishH5.vue?vue&type=script&lang=js"
import style0 from "./publishH5.vue?vue&type=style&index=0&id=c3990dc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3990dc0",
  null
  
)

export default component.exports